/**
 * @generated SignedSource<<44fc5c16331a607dc763da8623983256>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedSellers_itemSearch$data = {
  readonly meta: {
    readonly header: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSeller_itemSearch">;
  readonly " $fragmentType": "SbSharedRelatedSellers_itemSearch";
};
export type SbSharedRelatedSellers_itemSearch$key = {
  readonly " $data"?: SbSharedRelatedSellers_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSellers_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedSellers_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedSeller_itemSearch"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "07bc0c291a1ea8f233f424952750b54d";

export default node;
